export default "__VITE_PUBLIC_ASSET__d01ad595__"